import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { tableItem, headerCardStyle, footerCardStyle } from './style'
import classnames from 'classnames'

class TableItem extends PureComponent {
  static propTypes = {
    fields: PropTypes.arrayOf(PropTypes.object).isRequired,
    item: PropTypes.object.isRequired,
    onClick: PropTypes.func,
    showHeaderCard: PropTypes.any
  }

  static defaultProps = {
    onClick: () => {},
    showHeaderCard: false,
    showExtraContent: false
  }

  headerCard = (item, fields) => {
    const items = fields.map((field, index) => {
      if (!field.headerCard) {
        return null
      }
      return (
        <div className="header-card-item" key={index}>
          {field.renderContentCard
            ? field.renderContentCard(item)
            : field.render
            ? field.render(item)
            : item[field.key]}
          <style jsx>{headerCardStyle}</style>
        </div>
      )
    })

    return (
      <div className="header-card-container">
        {items}
        <style jsx>{headerCardStyle}</style>
      </div>
    )
  }

  renderExtraContent = (item, fields) => {
    const items = fields.map((field, index) => {
      if (!field.renderExtraContent) {
        return null
      }
      return field.renderExtraContent(item)
    })
    return (
      <div className="footer-card-item">
        {items}
        <style jsx>{footerCardStyle}</style>
      </div>
    )
  }

  captionField = field => {
    if (!field.key) {
      return null
    }
    return (
      <span className="table-item-caption-field">
        <strong>{field.caption}: </strong>
        <style jsx>{tableItem}</style>
      </span>
    )
  }

  onClick = () => {
    this.props.onClick(this.props.item)
  }

  render() {
    const {
      item,
      fields,
      showHeaderCard,
      scrollTable,
      showExtraContent
    } = this.props

    return (
      <div
        className={classnames('table-item-container', { scroll: scrollTable })}
        onClick={this.onClick}
      >
        {showHeaderCard && this.headerCard(item, fields)}
        {fields.map((field, index) => {
          const itemValue = item[field.key]
          const renderValue = field.render || (() => itemValue)
          return (
            <div
              key={`${this.key}-${index}`}
              className={classnames('table-item-field', {
                'header-card-field': field.headerCard,
                'hidde-on-mobile': field.hiddeOnMobile
              })}
              style={{ width: field.width }}
            >
              {this.captionField(field)}{' '}
              <span> {renderValue.apply(null, [item])} </span>
            </div>
          )
        })}
        {showExtraContent && this.renderExtraContent(item, fields)}
        <style jsx>{tableItem}</style>
      </div>
    )
  }
}

export default TableItem
